import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowLeft } from 'lucide-react';

const headingStyle = { fontFamily: "'Space Grotesk', system-ui, sans-serif" };

export default function CortexPreorderSuccess() {
  return (
    <div className="min-h-screen bg-[#0B1120] text-white flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <div className="mx-auto mb-8 w-20 h-20 rounded-full bg-[#3EF1C7]/10 flex items-center justify-center">
          <Check className="w-10 h-10 text-[#3EF1C7]" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={headingStyle}>
          Your Cortex is reserved.
        </h1>
        <p className="text-[#94A3B8] mb-2">
          We've received your <span className="text-[#FFD166] font-medium">$20 refundable deposit</span>.
          A confirmation email is on its way.
        </p>
        <p className="text-[#64748B] text-sm mb-10">
          The balance is due only when your unit ships (planned Q1 2027). You can
          request a full refund any time before then.
        </p>

        <div className="rounded-2xl border border-[#22304A] bg-[#0D1628] p-6 text-left mb-10">
          <h2 className="text-sm font-semibold mb-4 text-[#E2E8F0]" style={headingStyle}>
            What happens next
          </h2>
          <ul className="space-y-3 text-sm text-[#94A3B8]">
            {[
              'You hold a spot in the first production run.',
              'We email you ship-date updates and early-adopter perks.',
              'Before shipment, you confirm and pay the balance — or get a full refund.',
            ].map((t) => (
              <li key={t} className="flex items-start gap-2">
                <Check className="w-4 h-4 text-[#3EF1C7] mt-0.5 flex-shrink-0" />
                {t}
              </li>
            ))}
          </ul>
        </div>

        <Link
          to="/cortex"
          className="inline-flex items-center gap-2 text-[#FFD166] hover:text-[#FFE599] transition-colors font-medium"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Cortex
        </Link>
      </div>
    </div>
  );
}
